/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#shared/api/client'
import type { UpdateMeOptions, UpdateMeResponses } from '../models/UpdateMe'
import { client } from '#shared/api/client'

/**
 * @description Idempotent: the same body twice leaves the same account, and clearing an
 * absent email is a `204` like any other. Nothing is returned; the
 * dashboard reads the account back through `GET /api/me`.
 * @summary Sets or clears the account's email.
 * {@link /api/me}
 */
export function updateMe<ThrowOnError extends boolean = true>(options: Options<UpdateMeOptions, ThrowOnError>): Promise<RequestResult<UpdateMeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'PATCH', url: '/api/me', security: [{ type: 'apiKey', name: 'cas_session', in: 'cookie' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<UpdateMeResponses, ThrowOnError>>
}
